import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { LicensesSignalFacade } from 'mbs-ui-shared@facades/licenses-signal.facade';

@Component({
  selector: 'mbs-license-mode-label',
  templateUrl: './license-mode-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [I18NextPipe]
})
export class LicenseModeLabelComponent {
  private facade = inject(LicensesSignalFacade);

  public isPostPayment = this.facade.isPostPayment;
  public isYearlyLicenseMode = this.facade.isYearlyLicenseMode;
  public isMonthlyLicenseMode = this.facade.isMonthlyLicenseMode;
}
